import { boot } from 'quasar/wrappers'
import { date as q_date } from 'quasar'


const dateFormat = (date, separator = '.') => {
  const format = q_date.formatDate(date, `DD${separator}MM${separator}YYYY`)
  return format
}

export default boot(({ app }) => {
  const date = {
    dateFormat,
  }
  app.config.globalProperties.$date = date
})

